"use client";

import { useRouter } from "@/i18n/routing";
import { airStationSlug } from "@/lib/data/air-quality";
import type { AirStationMapItem } from "@/lib/types/air";
import type { Point } from "@/lib/types/other";
import dynamic from "next/dynamic";
import React from "react";
import type { AirStationMapLabels } from "../../../_components/AirStationMapCanvas";

const AirStationMapCanvas = dynamic(
  () => import("../../../_components/AirStationMapCanvas"),
  { ssr: false },
);

type Props = {
  points: AirStationMapItem[];
  center: Point;
  labels: AirStationMapLabels;
  zoom?: number;
};

const AirCityDetailMapView: React.FC<Props> = ({
  points,
  center,
  labels,
  zoom = 10,
}) => {
  const router = useRouter();

  return (
    <AirStationMapCanvas
      center={center}
      labels={labels}
      onStationSelect={(id) => {
        router.push(
          `/resource/air-quality/station/${airStationSlug.getSlug(id)}`,
        );
      }}
      stations={points}
      zoom={zoom}
    />
  );
};

export default AirCityDetailMapView;
